export default __webpack_public_path__ + "static/1.9-Colour-Alone-DONT-35eb3614c5c565cd519a8a3be57bc144.png";